

import { useState } from "react";
import { useSelector, useDispatch } from "react-redux"
import { RootState } from '../../../setup/redux/RootReducer'
import {sendFile} from '../fileSend/redux/FileSender'


export default function PreviewPage(){
    
    const [responseList, setResponseList] = useState<string []>();
    const [sendOrderLoading, setSendOrderLoading] = useState(false)
    const orderGroups = useSelector((state: RootState) => state.orderReducer.OrderGroup);
    console.log("Order error mes. => ",orderGroups?.some(x=> x?.orderList.filter(y=> y.ErrorMessageList != null && y.ErrorMessageList.length > 0)));
    console.log("order group",orderGroups)
    let errorFlag = orderGroups?.length > 0 ? (orderGroups?.some(x=> x.orderList?.find(y=> y.ErrorMessageList != null && y.ErrorMessageList.length > 0))) : true;  
    

    const createOrder =async () =>  {
       setResponseList([]);
       setSendOrderLoading(true);
       var response = await sendFile(orderGroups);
       console.log("Response 20 =>",response);
       if(response?.data?.Detail){
        setResponseList(response.data.Detail as string[]);
       }
       console.log("ResponseList =>",responseList);
       setSendOrderLoading(false);
    }
    

    return (
    <div className={`card card-xxl-stretch`}>
        <div className='card-body pt-5'>
           {orderGroups != null && orderGroups.length > 0  &&
            <table className="table table-hover table-rounded table-striped border gy-4 gs-7" style={{marginTop:20,marginBottom:20}}>
            <thead>
                <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                    <th>DeliveryStoreID</th>
                    <th>Address</th>
                    <th>StoreKey</th>
                    <th>CustNo</th>
                    <th>CHID</th>
                    <th>SubSys</th>
                    <th>Miktar</th>
                    <th>Hata Mesajı</th>
                </tr>
            </thead>
            <tbody>
                {orderGroups.map(order => (
                  <>
                  <tr key={order.RowNumber} style={{backgroundColor:'gray'}}>
                       <td colSpan={8}><b>{order.RowNumber}. Sipariş</b></td>
                  </tr>
                        {order.orderList.map(orderLine =>(
                                <tr key={orderLine.SubSys}>
                                    <td>{orderLine.DeliveryStoreID}</td>
                                    <td>{orderLine.Address}</td>
                                    <td>{orderLine.StoreKey}</td>
                                    <td>{orderLine.CustNo}</td>
                                    <td>{orderLine.CHID}</td>
                                    <td>{orderLine.SubSys}</td>
                                    <td>{orderLine.Miktar}</td>
                                    <td>
                                    {orderLine?.ErrorMessageList.map(errorMes => 
                                        <>
                                            <span key={errorMes} style={{color:'red',paddingBottom:3}}>{errorMes}</span>
                                            <br/> 
                                        </>
                                        )}
                                    </td>
                                </tr>
                        ))}
                </>
                ))}             
            </tbody>                     
       </table>}
      { !errorFlag && <div>
            <button className="btn btn-success" onClick={createOrder} disabled={sendOrderLoading}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-cart-check" viewBox="0 0 16 16" style={{marginRight: 7,marginBottom:4}}>
                <path d="M11.354 6.354a.5.5 0 0 0-.708-.708L8 8.293 6.854 7.146a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"/>
                <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zm3.915 10L3.102 4h10.796l-1.313 7h-8.17zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
            </svg>
            {!sendOrderLoading && <span className='indicator-label'>Sipariş oluştur</span>}
            {sendOrderLoading && (
                <span className='indicator-progress' style={{display: 'inline'}}>
                    Sipariş yükleniyor...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
            )}
            </button>
        </div>}

        {responseList != undefined && responseList.length >  0 && 
        <table className="table table-hover table-rounded table-striped border gy-4 gs-7" style={{marginTop:20,marginBottom:20}}>
            <thead>
                <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                    <th>Servis Cevabı</th>
                </tr>
            </thead>
            <tbody>
                {responseList?.map(element => (
                <>
                  <tr>
                      <td>{element}</td>
                  </tr>  
                  </>
                ))}
            </tbody>
        </table>}
        </div>
    </div>
    )
}